export type PrecedenceItem = {
  name: string;
  value: number;
};

export function precedence(): PrecedenceItem[] {
  return [
    { value: 0, name: 'routine' },
    { value: 1, name: 'priority' },
    { value: 2, name: 'immediate' },
    { value: 3, name: 'flash' },
    { value: 4, name: 'flash-override' },
    { value: 5, name: 'critical' },
    { value: 6, name: 'internet' },
    { value: 7, name: 'network' },
  ];
}
